import { useState, useEffect } from 'react';

function getDeviceType() {
    // Use window width to determine device type
    const threshold = 768; // Threshold in pixels to distinguish smartphones from laptops/desktops
    const width = window.innerWidth;

    if (width < threshold) {
        return "smartphone";
    } else {
        return "laptop/desktop";
    }
}

// Custom hook to determine device type
export const useDeviceType = () => {
    const [deviceType, setDeviceType] = useState(getDeviceType());

    useEffect(() => {
        const checkDeviceType = () => {
            setDeviceType(getDeviceType());
        };

        // Check on every window resize
        window.addEventListener('resize', checkDeviceType);

        // Cleanup listener on component unmount
        return () => window.removeEventListener('resize', checkDeviceType);
    }, []); // Empty dependency array means this effect runs only once on mount

    return deviceType;
};
